module.exports = __webpack_public_path__ + "img/icon-setting.9a2b106d.svg";